import { useContext } from 'react';
import { useQuery } from 'react-query';
import { apiGet } from 'api';
import AuthContext from 'context/auth-context';

const getDataUpdates = async (token, municipalityId) => {
  const url = `admin/municipalities/${municipalityId}/data_updates`;
  const data = await apiGet({ url, token });
  return data;
};

export function useAdminMunicipalityDataUpdates({ municipalityId, options } = {}) {
  const token = useContext(AuthContext);
  const queryFn = () => getDataUpdates(token, municipalityId);
  const queryKey = ['admin-municipality-data-updates', municipalityId];
  return useQuery(queryKey, queryFn, { enabled: !!municipalityId, ...options });
}
